module.exports = __webpack_public_path__ + "static/media/ye.2e634fdc.jpeg";